import {
  RAW_ORDER_FAILED,
  RAW_ORDER_REQUEST,
  RAW_ORDER_SUCCESS,
} from "app/redux/actions/Order/RawOrder/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const rawOrderOrderReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case RAW_ORDER_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case RAW_ORDER_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case RAW_ORDER_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
